import React from "react";

export function useListener(element: EventTarget, ev: string, listener: (this: EventTarget, ev: Event) => any) {
    React.useEffect(() => {
        element.addEventListener(ev, listener)
        return () => element.removeEventListener(ev, listener)
    })
}
